import React, { useEffect, useRef, useState } from 'react'
import useStore from '../../Store/Store.js'
import useFilterStore from '../../Store/filterStore.js'
import styles from './address.module.css'

const DEBOUNCE_MS = 1000

function Address () {
  const { address, setAddress, isQueryLoading } = useStore()
  const { allFilters, setAllFilters } = useFilterStore()
  const [inputValue, setInputValue] = useState(address ?? '')
  const timerRef = useRef(null)

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    if (inputValue === (address ?? '')) return
    timerRef.current = setTimeout(() => {
      const trimmed = inputValue.trim()
      setAddress(inputValue)
      if (trimmed && allFilters.streetAddress?.length > 0) {
        setAllFilters({ streetAddress: [] })
      }
    }, DEBOUNCE_MS)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [inputValue, address, setAddress, allFilters.streetAddress, setAllFilters])

  useEffect(() => {
    setInputValue(address ?? '')
  }, [address])

  return (
    <div className={styles.container}>
      <span className={styles.label}>Address</span>
      <input
        className={styles.input}
        type='text'
        id='prevent_autofill'
        autoComplete='off'
        placeholder='City, Address, State/Province, Zip'
        value={inputValue}
        disabled={isQueryLoading}
        onChange={e => setInputValue(e.target.value)}
      />
    </div>
  )
}

export default Address
